import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import { getStrengthenQuestions } from '../../services/strengthenQuestionService';
import globalActionConstants from '../constants/globalActionConstants';
import strengthenQuestionConstants from '../constants/strengthenQuestionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getCandidateStrengthenQuestions = (uuid, successCallBack) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await getStrengthenQuestions(uuid);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({
        type: strengthenQuestionConstants.GET_STRENGTHEN_QUESTION,
        payload: response.data.payload,
      });
      successCallBack(response.data.payload.strength_questions_data);
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    Notification.error(t('notifications.somethingWentWrong'));
  } finally {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  }
};
